<template>
  <RoamTransactionListTemplate
    :screenConfig="setScreenConfig"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :formsConfig="formsConfig"
  />
</template>

<script>
import RoamTransactionListTemplate from "../../../templates/roam/roam-transaction-list.vue";
import RouteMixin from "@/_mixins/route.mixin";
export default {
  mixins: [RouteMixin],
  components: {
    RoamTransactionListTemplate,
  },
  data() {
    return {
      despatchScanType: "",
    };
  },
  computed: {
    setScreenConfig() {
      var config = {
        title: "Location List",
        // ScreenName: "Sales Orders - To Despatch",
        selectedIndex: 1,
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "BinLocation",
              filter: [["Inactive", "=", "N"]],
              serverPaging: true,
              allowGrouping: false,
            },
            // noDataMessage: {
            //   addNew: {
            //     class: "add-new",
            //     title: "No Locations",
            //     // message:
            //     //   "No Locations",
            //   },
            // },
            options: {
              pageSize: 50,
              allowedPageSizes: [25, 50, 100],
              wordWrapEnabled: this.isXSmall ? false : true,
            },
            rowSelect: {
              view: this,
              page: "roam-bin-movement",
              mode: "edit",
              idProperty: "Code",
            },
          },

          toolbar: {
            search: true,
            columnChooser: false,
            export: false,
            openFilter: false,
            expand: false,
          },
          columns: [
            {
              screenField: "Code",
              gridDataField: "Code",
              gridLabel: "Loc. Code",
              sortOrder: "asc",
              sortIndex: 0,
              minWidth: 115,
              allowHiding: false,
            },
            {
              screenField: "Location",
              gridLabel: "Loc. Desc.",
              // cssClass: this.isXSmall ? "set-text-overflow" : undefined,
              minWidth: this.isXSmall ? 120 : undefined,
              width: this.isXSmall ? 120 : undefined,
            },
            {
              screenField: "Site",
              minWidth: 100,
              width: 100,
            },

            {
              screenField: "Status",
              gridDataField: "Inactive",
              gridLabel: "Status",
              fixed: false,
            },
          ],
        },
      };

      return config;
    },
  },
  methods: {
    async barcodeScanned(barcode) {
      if (barcode) {
        // eslint-disable-next-line no-console
        console.log("barcode", barcode);
      }
    },
  },
  async created() {},
};
</script>
